import { PlanillaPartido, PlanillaPartidoJSON } from '../PlanillaPartido/PlanillaPartido';
export interface PlanillaPartidoPdfJSON {
  ppp_id: string;
  ppp_ppid: string;
  ppp_ruta_pdf: string;
  ppp_fecha_generacion: Date | null;
}

export class PlanillaPartidoPdf {
  protected constructor(
    private id: string,
    private ppid: string,
    private rutaPdf: string,
    private fechaGeneracion: Date,
  ) {}

  static createFrom(
    id: string,
    ppid: string,
    rutaPdf: string,
    fechaGeneracion: Date,
  ) {
    return new this(id, ppid, rutaPdf, fechaGeneracion);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: PlanillaPartidoPdf) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: PlanillaPartidoPdfJSON) {
    return PlanillaPartidoPdf.createFrom(
      entity.ppp_id,
      entity.ppp_ppid,
      entity.ppp_ruta_pdf,
      entity.ppp_fecha_generacion ? new Date(entity.ppp_fecha_generacion) : new Date(),
    );
  }

  toJSON(): PlanillaPartidoPdfJSON {
    return {
      ppp_id: this.getId(),
      ppp_ppid: this.getPpid(),
      ppp_ruta_pdf: this.getRutaPdf(),
      ppp_fecha_generacion: this.getFechaGeneracion(),
    };
  }

  getId(): string {
    return this.id;
  }

  getPpid(): string {
    return this.ppid;
  }

  getRutaPdf(): string {
    return this.rutaPdf;
  }

  getFechaGeneracion(): Date {
    return this.fechaGeneracion;
  }

}
